export const ELEMENT_TYPE_TEXT = 'text';
export const ELEMENT_TYPE_DESIGN = 'design';
export const ELEMENT_TYPE_UPLOAD = 'upload';
export const ELEMENT_TYPE_EXTERNAL = 'external';
export const ELEMENT_TYPE_GROUP = 'group';
export const DEFAULT_RECTANGLE_CLIP_PATH = 'M 0 0 v 1 h 1 v-1 h-1';
